
import { defineComponent } from 'vue';
import BabylonExample from './components/BabylonExample.vue';

export default defineComponent({
  name: 'App',
  components: {
    BabylonExample
}
});
